import React, { useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import CategoryToolbar from "./components/CategoryToolbar";
import CategoryCard from "./components/CategoryCard";
import AddCategoryModal from "./components/AddCategoryModal";
import EditCategoryModal from "./components/EditCategoryModal";
import DeleteCategoryModal from "./components/DeleteCategoryModal";
import { useModalManager } from "shared/hooks/useModalManager";
import EmptyStateComponent from "shared/ui/empty";
import { useCategories } from "./hooks/useCategories";

// Categories feature — дэлгэц (UI orchestration). Логик нь useCategories-д.
export default function CategoriesScreen() {
  const { categories, loading, error, refetch } = useCategories();
  const { closeModal, currentModal, openModal } = useModalManager();

  // Засах/устгахаар СОНГОСОН мөр (тухайн үйлдлийн бай).
  const [selectedCat, setSelectedCat] = useState({});
  // «Нэмэх» дарсан багана: дээд түвшин → null (root), дэд → activeCat.id.
  const [addParentId, setAddParentId] = useState(null);

  const [searchParams, setSearchParams] = useSearchParams();
  const catId = searchParams.get("cat");

  // ⭐ activeCat-ийг жагсаалтаас ДЕРИВАТИВ болгов — refetch хийхэд баруун багана
  //    автоматаар шинэчлэгдэнэ (өмнө нь тусдаа state-д хадгалж, reload шаарддаг байв).
  const activeCat = useMemo(
    () => categories.find((c) => String(c.id) === String(catId)) || null,
    [categories, catId],
  );

  const onSelect = (category) => {
    if (!category) return;
    searchParams.set("cat", category.id);
    setSearchParams(searchParams);
  };

  const onEditClick = (category) => {
    setSelectedCat(category);
    openModal("edit-category");
  };

  const onDeleteClick = (category) => {
    setSelectedCat(category);
    openModal("delete-category");
  };

  // Нэмэх/засах/устгасны дараа: modal хаагаад жагсаалтыг дахин татна.
  const handleSaved = () => {
    closeModal();
    refetch();
  };

  return (
    <div className="container-fluid app">
      <div className="row">
        <div className="col-12">
          <CategoryToolbar onRefetch={refetch} />
          <h4 className="page-title mt-3">Ангилал засах</h4>
        </div>
      </div>

      {error ? (
        <div className="alert alert-warning" role="alert">
          {error}{" "}
          <button className="btn btn-sm btn-link p-0" onClick={refetch}>
            Дахин оролдох
          </button>
        </div>
      ) : null}

      <div className="row">
        <CategoryCard
          loading={loading}
          title="Ангилал"
          onAddClick={() => {
            setAddParentId(null); // дээд түвшин → root
            openModal("add-category");
          }}
          onEditClick={onEditClick}
          onDeleteClick={onDeleteClick}
          categories={categories}
          onSelect={onSelect}
        />
        {activeCat ? (
          <CategoryCard
            title={activeCat.name}
            onAddClick={() => {
              setAddParentId(activeCat.id); // дэд багана → хүүхэд
              openModal("add-category");
            }}
            onEditClick={onEditClick}
            onDeleteClick={onDeleteClick}
            loading={loading}
            categories={activeCat.children}
            onSelect={null}
          />
        ) : (
          <div className="col-lg-6 col-md-12">
            <div className="card">
              <div className="card-body pt-0">
                <div className="table-responsive mt-n2">
                  <EmptyStateComponent title="Ангилал сонгоно уу" />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      <AddCategoryModal
        show={currentModal === "add-category"}
        handleClose={closeModal}
        parentId={addParentId}
        onSaved={handleSaved}
      />
      <EditCategoryModal
        show={currentModal === "edit-category"}
        handleClose={closeModal}
        category={selectedCat}
        onSaved={handleSaved}
      />
      <DeleteCategoryModal
        show={currentModal === "delete-category"}
        handleClose={closeModal}
        category={selectedCat}
        onSaved={handleSaved}
      />
    </div>
  );
}
